// console.log FOR EVERYONE http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

jQuery.fn.setAllToMaxHeight = function(){
   return this.height( Math.max.apply(this, jQuery.map( this , function(e){ return jQuery(e).height() }) ) );
}

if (true) {
    slideDuration = 10000;
} else {
    slideDuration = 0;
}


function showBackTop(posTop){
    if (posTop > 200) {
        $('#back-top').fadeIn(200);
    } else {
        $('#back-top').fadeOut(200);
    }
}


function doResize(){
   $('body#index ul.collection-list .thumbnail').removeAttr("style").setAllToMaxHeight();
   $('ul.collection-th li a.prod-th').removeAttr("style").setAllToMaxHeight();
}


// resize but not too often
var resizeDelay;
$(window).resize(function() {
    clearTimeout(resizeDelay);
    resizeDelay = setTimeout(function() {
        doResize();
    }, 50);
});


//ipad refresh on rotate
if (window.addEventListener) {
    window.addEventListener("orientationchange", function() {
        window.location.reload();
    }, false);
}


// preload images
$.fn.preload = function() {
    this.each(function(){
        $('<img/>')[0].src = this;
    });
}



jQuery(document).ready(function($){

   // Language for Magnific popup
   $.extend(true, $.magnificPopup.defaults, {
     tClose: "Close (Esc)", // Alt text on close button
     tLoading: "Loading...", // Text that is displayed during loading. Can contain %curr% and %total% keys
     gallery: {
       tPrev: "Previous (Left arrow key)", // Alt text on left arrow
       tNext: "Next (Right arrow key)", // Alt text on right arrow
       tCounter: '%curr% ' + "of" + ' %total%' // Markup for "1 of 7" counter
     }
   });


    $('ul.collection-th .thumbnail, body#index ul.collection-list .thumbnail').imagesLoaded( function() {
        //images have loaded
        doResize();
    });

    $(document).on('click', '#menu .top-search .icon-magnifier', function(){
        var $topSearch = $('#menu .top-search');
        $topSearch.toggleClass('active');
        if ($topSearch.hasClass("active")){
            $topSearch.find('input').focus();
        }
    });

    $(document).on('click', "span.quick-view", function(e){
        e.preventDefault();
        e.stopPropagation();
        $.magnificPopup.open({
            items: {
            src: $(this).data('prdid'),
            type: 'inline'
            }
        });
    });

    if ($(window).width() > 900) {
        $(".prod-th").mouseenter(function(e){
            $(".quick-view").hide();
            $(".quick-view", this).stop().fadeIn(300);
        }).mouseleave(function(e){
            $(".quick-view").hide();
        });
    }

    var $mobileNav = $("<div class='mobile-nav'><a class='mobile-button' id='show-nav' href='#'><span class='icon-list'></span> " + "Menu" +"</a><a class='mobile-button' id='mini-cart' href='/cart'><span class='icon-cart3'></span>" + "Cart" +"</a></div>");
    var $menu = $("#menu");
    // clone menu for mobile and remove id
    var $newNav = $menu.clone();
    $newNav.removeAttr('id');
    $newNav.addClass('mobile-menu');
    $mobileNav.append($newNav);

    $("body").prepend($mobileNav);

    $newNav.find('li.has-sub > a').each(function() {
        var tis = $(this);
        var state = false;
        var subMenu = tis.next('ul').slideUp();
        tis.on('click', function(e) {
            e.preventDefault();
            state = !state;
            subMenu.slideToggle(state);
            tis.closest('li').toggleClass('active',state);
        });
    });

    $('#show-nav').on('click', function() {
        $("ul.mobile-menu").slideToggle();
    });

    function initMenu(){
        $menu.find('.open').removeClass('open');
    }

    $(document).on('click', '#menu.click-me .has-sub > a', function(e){
        // handle desktop menu clicks
        e.preventDefault();
        e.stopPropagation();
        $this = $(this);
        $thisParent = $this.parent();
        if ($thisParent.hasClass('level-1')){
            if ($thisParent.hasClass('open')){
                initMenu();
            } else {
                initMenu();
                $thisParent.addClass('open');
                $this.next('ul').toggleClass('open');
            }
        } else {
            if ($this.next('ul').hasClass('open')){
                // hide the sub attached to this link
                $thisParent.find('ul').removeClass('open');
            } else {
                // close any open subs and then open sub attached to this link
                $this.closest('ul.open').find('ul').removeClass('open');
                $this.next('ul').addClass('open');
            }
        }
    });

    var $slides = $('#slides');

   if($slides.find("div").length === 1){
      $slides.parent().addClass('single-slide');
    }

    $slides.before("<div class='slide-prev'><span class='icon-arrow-large-left'></span></div><div class='slide-next'><span class='icon-arrow-large-right'></span></div>");
    $slides.after("<div class='slide-pager'></div>");

    $slides.find('img').each(function(){
        $('#slideshow .slide-pager').append("<a href='#'></a>");
    });


    $slides.on( 'cycle-initialized', function(event, optionHash) {
        //not needed
    });


    $slides.on( 'cycle-update-view', function( e, opts ) {
        // show captions
        var currSlide = $(this);
        currSlide.find('.caption1').addClass('animate1');
        currSlide.find('.caption2').addClass('animate2');
        currSlide.find('.cta').addClass('animate2');
    });

    $slides.on( 'cycle-before', function( e, opts ) {
        // hide captions
        var slideshow = $(this);
        var img = slideshow.find('.caption').removeClass('animate1').removeClass('animate2');
    });

  
     var slideEasing = null;
     var slideSpeed = 1000;
  


   $slides.cycle({
      speed: slideSpeed,
        timeout: slideDuration,
        fx: 'fade',
        slides: '.slide',
        prev: '.slide-prev',
        next: '.slide-next',
        pager: '#slideshow .slide-pager',
        swipe: true,
        easing: slideEasing,
        pagerTemplate: ''
    });


    if (false){
        // get top offset of menu
        var menuOffset = $('#menu').offset().top;
        var stickyNav = function(){
            var scrollTop = $(window).scrollTop();
            if (scrollTop > menuOffset) {
                $('#menu').addClass("fixed");
            } else {
                $('#menu').removeClass("fixed");
            }
        }
        // position menu on load
        stickyNav();
    }

    $(window).scroll(function() {
        showBackTop($(this).scrollTop());
        if (false){
            stickyNav();
        }
    });

    // Animate the scroll to top
    $('#back-top').on('click', function(event) {
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 300);
    });


    // preload gallery images
    var galleryImg = [];
    $("#more-images a").each(function(){
        imgUrl = $(this).prop("href");
        galleryImg.push(imgUrl);
    });
    // Pass the array to our preload function
    $(galleryImg).preload();


   $('#more-images').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
         enabled: true
      },
      mainClass: 'mfp-fade'
   });

   $('#product-shot').on('click', function(e) {
      e.preventDefault();
      var imageId = $(this).data('image-id');
      $('.smallimg[data-image-id="' + imageId + '"]').trigger("click");
	});

    $('.qview .main-image').on('click', function(e){
      e.preventDefault();
    });

    $('a.go-back').on('click', function(e) {
        e.preventDefault();
        window.location.href = "/";
    });

    $('a.cart-update').on('click', function(e) {
        e.preventDefault();
        $('form#cartform').submit();
    });

    $("#content").fitVids();

    // hide big footer if no content
    var $bigFooter = $('.social-row .inner > div');
    var bigFootCnt = $bigFooter.find("div").length;
    if (bigFootCnt === 0){
        $('.social-row').hide();
    }

    $('.social-icons a').prop('target','_blank');


   
      // don't enable zoom on small devices - to avoid difficult scrolling
      if ($(window).width() > 760) {
         $('a#product-shot').zoom({url: $(this).prop("href")});
      }
   


    
       $('.qview .main-image').zoom({});
    


    var owl = $("#more-images");
    owl.owlCarousel({
      loop: true,
       itemsCustom : [
          [0, 3],
          [320, 3],
          [640, 3]
       ],
       items : 3,
       rewindSpeed : 400, 
       navigation:true,
       navigationText : ["<span class='icon-arrow-large-left'></span>","<span class='icon-arrow-large-right'></span>"]
    });

    RESPONSIVEUI.responsiveTabs();

    $('.gt-accordion h4').each(function() {
       var tis = $(this), state = false, answer = tis.next('div').slideUp();
       tis.click(function() {
          state = !state;
          answer.slideToggle(state);
          tis.toggleClass('active',state);
       });
    });

   // product variant callback
   var currencyFormat = $('body').data('curr-format');
   var shopCurrency = $('body').data('curr-code');
   selectCallback = function(variant, selector) {
      var $product = $('#prod-' + selector.product.id);
      $('.var-msg', $product).html('').hide();
      if (variant) {
         if (variant.available) {
            // Selected a valid variant that is available
            // enable buy button
            $('.purchase', $product).removeClass('disabled').removeAttr('disabled');

            
               // If item is backordered yet can still be ordered, we'll show special message
               if (variant.inventory_management && variant.inventory_quantity <= 0) {
                 $('.var-msg', $product).html("").fadeIn(200);
               }
            
         } else {
            // Variant is sold out
            $('.var-msg', $product).html("Due to high demand, this product is temporarily out of stock").fadeIn(200);
            $('.purchase', $product).addClass('disabled').attr('disabled', 'disabled');
         }

         // Whether the variant is in stock or not, we can update the prices
         $('.product-price', $product).html(Shopify.formatMoney(variant.price, currencyFormat));
         if ( variant.compare_at_price > variant.price ) {
            $('.product-compare-price', $product).html(Shopify.formatMoney(variant.compare_at_price, currencyFormat));
         }else{
            $('.product-compare-price', $product).html('');
         }

   		 if (variant.featured_image) {
      		var original_image = $(".main-image img", $product), new_image = variant.featured_image;
      		Shopify.Image.switchImage(new_image, original_image[0], function (new_image_src, original_image,element) {
         		$(element).parents('a').attr('href', new_image_src);
         		$(element).attr('src', new_image_src);
               $("#more-images a").removeClass('active-img');
               $('.smallimg[data-image-id="' + new_image.id + '"]').addClass('active-img');
               $('.main-image', $product).find('img').prop('src',new_image_src);
               $('.main-image', $product).data('image-id',new_image.id);
      		});
   		 }


      } else {
         // variant doesn't exist.
         $('.var-msg', $product).html("Unavailable").fadeIn(200);
      }

      
        var newCurrency = $('#currencies option:selected').val();
        if (newCurrency != shopCurrency){
           Currency.convertAll(shopCurrency, newCurrency);
        }
      
  };[...document.querySelectorAll('button.purchase.button')].forEach(atc=>{
      atc.onclick=e=>{
        e.preventDefault();
        atc.innerHTML = 'Adding...';
        atc.disabled = true;
        fetch('/cart/add.js', {
          body: new FormData(atc.closest('form')),
          method: "POST",
          credentials: 'include',
          headers: {"X-Requested-With": "XMLHttpRequest"}
        }).then(response=>response.json()).then(res=>{
          document.cookie = 'cf=yes; path=/; domain=www.joeskc.com; secure=true; max-age=43200';
          [...document.querySelectorAll('a.mini-cart>em')].forEach(count=>{count.innerHTML = `(${parseInt(count.innerHTML.replace('(','').replace(')','')) + res.quantity})`});
          atc.innerHTML = 'Added!';
          atc.disabled = false;
          setTimeout(()=>{atc.innerHTML = 'Add to Cart';cartCheck();},1500);
        });
      }
    });
    
      function getCookie(name) {
        var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
      }
      function cartCheck() {
        var clear = setInterval(()=>{
          if (getCookie('cf') != 'yes' && document.querySelector('a.mini-cart>em').innerHTML != '(0)'){
            clearInterval(clear);
            fetch('/cart/clear.js', {
              method: "POST",
              credentials: 'include',
              headers: {"X-Requested-With": "XMLHttpRequest"}
            }).then(response=>response.json()).then(res=>{
              [...document.querySelectorAll('a.mini-cart>em')].forEach(count=>{count.innerHTML = '(0)'});
              if (window.location.href.includes('/cart')){window.location.reload();}
            });
          }
        },9999);
      }
      if (getCookie('cf') != 'yes' && document.querySelector('a.mini-cart>em').innerHTML != '(0)'){
        fetch('/cart/clear.js', {
          method: "POST",
          credentials: 'include',
          headers: {"X-Requested-With": "XMLHttpRequest"}
        }).then(response=>response.json()).then(res=>{
          [...document.querySelectorAll('a.mini-cart>em')].forEach(count=>{count.innerHTML = '(0)'});
          if (window.location.href.includes('/cart')){window.location.reload();}
        });
      } else {
        cartCheck();
      }});
$(".sidebar-location.leawood").click(function() {
  window.location = $(this).find("a").attr("href"); 
  return false;
});